export default "__VITE_ASSET__CQEr5_PE__"